<template>
  <div>
    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoOther('home')"/>
      <div @click="gotoOther('home')">首页 ></div>
      <div style="padding-left: 6px;" @click="gotoOther('enterpriseIndex')"> 企业概况 ></div>
      <div class="text">技术展示</div>
    </div>

    <div class="tech-main">
      <div class="left-nav">
        <div class="nav-item" :class="{'nav-active': activeIndex == index}" v-for="(item, index) in techList" :key="item.id" @mouseenter="navMouseEnter(index)">
          <div>{{ item.subTitle | textFilter }}</div>
        </div>
      </div>

      <div class="right-content">
        <div class="title">{{ activeInfo.title }}</div>
        <div v-html="$utils.escape2Html(activeInfo.content)"></div>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: 0,
      techList: [],
      activeInfo: {}
    }
  },
  created() {
    if(this.$route.query?.realIndex) {
      this.activeIndex = this.$route.query?.realIndex
    }
    this.getTechList()
  },
  methods: {
    gotoOther(name) {
      this.$router.replace({name: name})
    },
    getTechList() {
      this.$http.getAction('/portal/api/v1/intro/technology').then((res) => {
        if (res.success) {
          this.techList = res.data
          if(res.data?.length > 0) {
            this.activeInfo = res.data[this.activeIndex]
          }
        }
      })
    },
    navMouseEnter(index) {
      if(index === this.activeIndex) return
      this.activeIndex = index
      this.activeInfo = this.techList[index]
    }
  },
  filters: {
    textFilter(text) {
      if(text?.length > 10) {
        return text.slice(0, 10)
      }
      return text
    }
  }
}
</script>
<style lang="scss" scoped>

.page-nav {
  display: flex;
  align-items: center;
  width: 1200px;
  margin: 30px auto 70px;
  font-weight: 500;
  font-size: 14px;
  color: #898989;
  line-height: 16px;
  cursor: pointer;
  img {
    width: 20px;
    height: 20px;
    margin-right: 15px;
  }
  .text {
    padding-left: 6px;
    color: #333333;
  }
}

.tech-main {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  .left-nav {
    width: 300px;
    max-height: 560px;
    overflow-y: auto;
    background: #FFFFFF;
    box-shadow: 0px 2px 15px 0px rgba(0,0,0,0.1);
    border-radius: 0px 0px 0px 0px;
    flex-shrink: 0;
    .nav-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 69px;
      border-bottom: 1px solid #D4D7D9;
      cursor: pointer;
      &:last-of-type {
        border-bottom: none;
      }
      div {
        white-space: nowrap;
        overflow: hidden;
        font-weight: 500;
        font-size: 20px;
        color: #000000;
      }
      // &:hover {
      //   background: rgba(2, 130, 222, 0.6);
      //   div {
      //     color: #fff;
      //   }
      // }
    }
    .nav-active {
      background: #0282de;
      div {
        // font-weight: 800;
        // font-size: 22px;
        color: #FFFFFF;
      }
    }
  }
  .right-content {
    flex: 1;
    padding: 0 70px;
    min-height: 600px;
    .title {
      padding: 15px 0;
      font-weight: 800;
      font-size: 26px;
      color: #000000;
      text-align: center;
    }
    .time {
      margin-top: 50px;
      margin-bottom: 20px;
      font-weight: 500;
      font-size: 12px;
      color: #5A5A5A;
      line-height: 18px;
    }
  }
}


</style>
